// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/feature-export/types.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/export/src/types.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo meal-planner-app
//     node fleet/fleet.ts check --repo meal-planner-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
/**
 * Generic, entity-agnostic data export model.
 *
 * The shape is intentionally tiny: a list of column descriptors, a list of
 * rows, and optional document metadata. Any entity (todo, note, transaction…)
 * is exported by writing an *adapter* that maps the domain records into a
 * {@link ExportDataset}. The CSV/PDF generators below never know about the
 * domain — they only consume this neutral structure.
 */

/** Primitive cell value. Adapters normalize everything to these. */
export type ExportCellValue = string | number | boolean | null | undefined;

/** Describes one output column and how to pull its value from a record. */
export interface ExportColumn<TRow> {
  /** Stable machine key (used as CSV header fallback). */
  key: string;
  /** Human-readable header shown in CSV/PDF output. */
  header: string;
  /** Extracts the cell value for this column from a record. */
  accessor: (row: TRow) => ExportCellValue;
}

/** Optional document-level metadata rendered in the PDF/HTML header. */
export interface ExportMetadata {
  /** Document title (e.g. "Tasks", or a list name). */
  title?: string;
  /** Optional subtitle / description. */
  subtitle?: string;
  /** ISO timestamp the export was generated; defaults to now. */
  generatedAt?: string;
  /** Free-form extra key/value pairs to render (e.g. account email). */
  extra?: Record<string, string>;
}

/**
 * Fully-resolved dataset: a flat table of headers + string-or-primitive cells,
 * plus metadata. Produced by {@link buildDataset} from columns + rows.
 */
export interface ExportDataset {
  columns: { key: string; header: string }[];
  /** Each row is the ordered list of cell values matching `columns`. */
  rows: ExportCellValue[][];
  metadata: ExportMetadata;
}

/**
 * Resolves columns + rows into a flat {@link ExportDataset}. Keeping this
 * separate from the generators means an adapter can be unit-tested by asserting
 * on the dataset alone.
 */
export function buildDataset<TRow>(
  columns: ExportColumn<TRow>[],
  rows: readonly TRow[],
  metadata: ExportMetadata = {},
): ExportDataset {
  return {
    columns: columns.map((c) => ({ key: c.key, header: c.header })),
    rows: rows.map((row) => columns.map((c) => c.accessor(row))),
    metadata: {
      ...metadata,
      generatedAt: metadata.generatedAt ?? new Date().toISOString(),
    },
  };
}
